var fullscreenApi = {};

// From http://johndyer.name/native-fullscreen-javascript-api-plus-jquery-plugin/
(function() {
    if(!global.document) {
        global.document = {}
    }

    var browserPrefixes = 'webkit moz o ms khtml'.split(' ');

    /* istanbul ignore next */
    fullscreenApi = {
        supportsFullScreen: false,
        isFullScreen: function() { return false; },
        requestFullScreen: function() {},
        cancelFullScreen: function() {},
        fullScreenEventName: '',
        prefix: ''
    };

    /* istanbul ignore next */
    if (typeof document.cancelFullScreen != 'undefined') {
        fullscreenApi.supportsFullScreen = true;

    /* istanbul ignore next */
    } else {
        // check for fullscreen support by vendor prefix
        for (var i = 0, il = browserPrefixes.length; i < il; i++ ) {
            fullscreenApi.prefix = browserPrefixes[i];

            if (typeof document[fullscreenApi.prefix + 'CancelFullScreen' ] != 'undefined' ) {
                fullscreenApi.supportsFullScreen = true;

                break;
            }
            if (typeof document[fullscreenApi.prefix + 'ExitFullscreen' ] != 'undefined' ) {
                fullscreenApi.supportsFullScreen = true;
                fullscreenApi.alternativeFunctionNames = true;

                break;
            }
        }
    }

    // update methods to do something useful
    /* istanbul ignore next */
    if (fullscreenApi.supportsFullScreen) {
        fullscreenApi.fullScreenEventName = fullscreenApi.prefix + 'fullscreenchange';

        fullscreenApi.isFullScreen = function() {
            switch (this.prefix) {
                case '':
                    return document.fullScreen;
                case 'webkit':
                    return document.webkitIsFullScreen;
                default:
                    return document[this.prefix + 'FullScreen'];
            }
        };
        fullscreenApi.requestFullScreen = function(el) {
            el = el || document.documentElement;

            if (!fullscreenApi.alternativeFunctionNames) {
                return (this.prefix === '') ? el.requestFullScreen() : el[this.prefix + 'RequestFullScreen']();
            }
            return (this.prefix === '') ? el.requestFullscreen() : el[this.prefix + 'RequestFullscreen']();
        };
        fullscreenApi.cancelFullScreen = function(el) {
            el = el || document.documentElement;
            if (!this.alternativeFunctionNames) {
                return (this.prefix === '') ? document.cancelFullScreen() : document[this.prefix + 'CancelFullScreen']();
            }
            return (this.prefix === '') ? document.exitFullscreen() : document[this.prefix + 'ExitFullscreen']();
        };
    }
})();

export default fullscreenApi;


// WEBPACK FOOTER //
// ./src/lib/fullscreen.js